export var sdkVersion = '2.1.1';
